/* eslint react-hooks/rules-of-hooks: "off" */
import EnumBase from './Base';
import { useTranslation } from 'react-i18next';

export default function packageTypesEnum() {
  const { t } = useTranslation();
  const trAddon = (addonType) => t(`addon.type.${addonType}`);
  return new EnumBase([
    { name: trAddon('users'), id: 'users' },
    { name: trAddon('doctor'), id: 'doctor' },
    { name: trAddon('doctor_all'), id: 'doctor_all' },
    { name: trAddon('emergency'), id: 'emergency' },
    { name: trAddon('driving'), id: 'driving' },
  ]);
}
